import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsSaas from '../../../components/video-production/explainer-videos/BenefitsSaas';
import ProcessSliderSaas from '../../../components/sliders/ProcessSliderSaas';
import SolveProblemsSaas from '../../../components/video-production/explainer-videos/SolveProblemsSaas';

lazyload({
  width: '100%',
});

const ExplainerVideosSaas = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Saas Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/saas-explainer-video" />
        <meta
          name="description"
          content="Explore the magic of SaaS with our awesome explainer video! See how our services can supercharge your business. Dive in now for a game-changing experience!"
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/saas-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Saas Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Explore the magic of SaaS with our awesome explainer video! See how our services can supercharge your business. Dive in now for a game-changing experience!"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/saas-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Saas Explainer Video | Prodigi",
  "description": "Explore the magic of SaaS with our awesome explainer video! See how our services can supercharge your business. Dive in now for a game-changing experience! ",
  "url": "https://weprodigi.com/video-production/saas-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Saas Explainer Video Production ",
        "item": "https://weprodigi.com/video-production/saas-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Saas Explainer Video Production",
    "description": "Explore the magic of SaaS with our awesome explainer video! 
See how our services can supercharge your business. Dive in now for a game-changing experience!",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Madlena Dimitrova"
        },
        "datePublished": "2024-03-19",
        "reviewBody": "Prodigi Agency's SaaS explainer video exceeded expectations! Finding a video that balances technical information with visual appeal so seamlessly is rare. Whether you're a tech novice or an expert, this video breaks down the benefits of Prodigi's services in a way that's easy to understand and impossible to ignore. Kudos to the team for a job well done!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Laura Bresley"
        },
        "datePublished": "2024-02-01",
        "reviewBody": "Impressed by Prodigi Agency's SaaS explainer video! In just a few minutes, it effectively communicated the value proposition of its services. The animation was sleek, the narration engaging, leaving viewers with a strong understanding of how Prodigi can revolutionize their operations. Well done!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Nora Navas"
        },
        "datePublished": "2024-02-02",
        "reviewBody": "Say goodbye to boring presentations and hello to innovation. With Prodigi, understanding complex software solutions has never been easier – or more enjoyable.Thank you!"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/saas-explainer/saas-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              SaaS Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/saas-explainer-video',
                name: 'SaaS Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A SaaS explainer video is a clear explanation of your cloud-based service. It will become noticeable and competitive in the diverse
                  market. The secret is a mixture of digital storytelling and catchy visualizations.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a SaaS Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/r2WCpU1iu7s?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Virtual Place | SAAS Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A SaaS explainer video is a short, interactive video clip. It provides a clear description of a service between 1-3 minutes. It gives
                a simple and concise explanation of the product's features, benefits, and particular problem solutions. Creative visualization shows
                the importance of your service. Thus, it inspires the target audience to take a step next to try it. As a result, it can clarify
                complex concepts about your product to improve customer experience.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A SaaS explainer video is a short, interactive video clip. It provides a clear description of a service between 1-3 minutes. It
                  gives a simple and concise explanation of the product's features, benefits, and particular problem solutions. Creative visualization
                  shows the importance of your service. Thus, it inspires the target audience to take a step next to try it. As a result, it can
                  clarify complex concepts about your product to improve customer experience.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use SaaS Explainer Videos?
            </h2>
            <p className={'mt-20'}>Are you looking for ways to introduce the values of your SaaS product? Discover the uses of an explainer video!</p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/ycIjg9Xp4rc?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Hello Guest | SAAS Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  There's a new way of reserving a spot in the market. SaaS marketing videos will connect your SaaS businesses and their potential
                  users. Videos are easy to share on various platforms. This benefit makes it possible to use them in social media ads, landing pages,
                  e-commerce or retail platforms, email marketing, etc. Visualised explanations bring higher engagement. Additionally, videos are very
                  good at introducing new software features to drive user engagement and conversions.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    There's a new way of reserving a spot in the market. SaaS marketing videos will connect your SaaS businesses and their potential
                    users. Videos are easy to share on various platforms. This benefit makes it possible to use them in social media ads, landing
                    pages, e-commerce or retail platforms, email marketing, etc. Visualised explanations bring higher engagement. Additionally, videos
                    are very good at introducing new software features to drive user engagement and conversions.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Software and Technology</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  SaaS provides various beneficial solutions to companies and individuals. A lot of processes become more accessible with these
                  services. Explainer videos for SaaS products make these non-material solutions visible and highly demanded. The video will
                  illustrate how your services work and what changes they can make in the user's life. It helps showcase the features and benefits of
                  your SaaS product. As a result, the video is handy and engaging.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    SaaS provides various beneficial solutions to companies and individuals. A lot of processes become more accessible with these
                    services. Explainer videos for SaaS products make these non-material solutions visible and highly demanded. The video will
                    illustrate how your services work and what changes they can make in the user's life. It helps showcase the features and benefits
                    of your SaaS product. As a result, the video is handy and engaging.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/6s-t27GvpHo?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Intellipse | SAAS Explainer Video </p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/uV2JsS1vQ-w?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>SimplyPayMe | SAAS Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Customer Onboarding</h3>
                <p className={'mt-16 hidden md:block'}>
                  Imagine you've made a great SaaS tool. But what if your customers have questions? The answer everyone is waiting for is a software
                  animation video with clear, concise, and engaging content. SaaS explainer videos explain all a product's features and concepts,
                  making it easy to understand. Coupled with catchy visuals, they leave a memorable impact and bring high engagement of potential
                  users. Also, they improve the FAQ section to assist new users in understanding the basics of the product.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Imagine you've made a great SaaS tool. But what if your customers have questions? The answer everyone is waiting for is a software
                    animation video with clear, concise, and engaging content. SaaS explainer videos explain all a product's features and concepts,
                    making it easy to understand. Coupled with catchy visuals, they leave a memorable impact and bring high engagement of potential
                    users. Also, they improve the FAQ section to assist new users in understanding the basics of the product.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Saas Explainer Videos
            </h2>
            <p className={'mt-20'}>Explainer video is a powerful tool for succeeding in your business goals. Here are the main benefits of it.</p>
            <Suspense fallback={`Loading...`}>
              <BenefitsSaas />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Saas Explainer Video Production Process
            </h2>
            <ProcessSliderSaas />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR SAAS EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Saas Explainer Videos Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              A SaaS explainer video is beneficial for community building and engaging audiences. Discover more about how it helps realise your
              business goals.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsSaas />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Saas Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Can I customise my SaaS explainer video to reflect my brand identity?',
                    answer: 'The flexible format of the SaaS explainer video makes it possible to reflect any brand identity.',
                  },
                  {
                    title: 'Are SaaS explainer videos suitable for all industries?',
                    answer: 'The right style of a SaaS explainer video will make it suitable for any industry.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'What makes SaaS explainer videos unique?',
                    answer:
                      'A professional script, a catchy soundtrack, and excellent sound effects are the primary keys to making SaaS explainer videos unique.',
                  },
                  {
                    title: 'Why should I care about SAAS?',
                    answer: 'It would help if you care about SaaS because it gives businesses and individuals access to a powerful software system.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosSaas;
